import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    value: 0,
}

export const vehicleTrackData = createSlice({
    name: 'vehicleTrackData',
    initialState,
    reducers: {
        addVehicleTrackData: (state, action) => {
            state.value = (action.payload);
        },
    },
})

// Action creators are generated for each case reducer function
export const { addVehicleTrackData } = vehicleTrackData.actions

export default vehicleTrackData.reducer